import React, { createContext, useContext, useState, useEffect } from "react";
import { getSecureItem, removeSecureItem, setSecureItem } from "../utils/LocalStorageManager";

interface Business {
  services: any;
  id: number;
  name: string;
  biz_code: string;
  package: string;
  expiry_date: string;
  'latitude': string | number;
  'longitude': string | number;
}

interface BusinessContextType {
  business: Business | null;
  setBusiness: (business: Business | null) => void;
  clearBusiness: () => void;
  setServices: (services: any) => void;
}

const BusinessContext = createContext<BusinessContextType | undefined>(undefined);

export const BusinessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [business, setBusinessState] = useState<Business | null>(null);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = getSecureItem("binfo");
    if (stored) setBusinessState(stored[0]);
  }, []);

  const setBusiness = (biz: Business | null) => {
    setBusinessState(biz);
    if (biz) {
      setSecureItem("binfo", [biz]);
    } else {
      removeSecureItem("binfo");
    }
  };

  const clearBusiness = () => {
    setBusinessState(null);
    removeSecureItem("binfo");
  };
  const setServices = (services: any) => {
    if (business) {
      const updatedBusiness = { ...business, services };
      setBusiness(updatedBusiness);
    }
  };
  return (
    <BusinessContext.Provider value={{ business, setBusiness, clearBusiness, setServices }}>
      {children}
    </BusinessContext.Provider>
  );
};

// Custom hook
export const useBusiness = () => {
  const context = useContext(BusinessContext);
  if (!context) throw new Error("useBusiness must be used within a BusinessProvider");
  return context;
};